// Canonical host for the sitemap, robots.txt, Open Graph, and structured data.
// thewastegame.co.uk, www.thewastegame.co.uk, and thewastegame.com
// permanently redirect here (see vercel.json).
export const SITE_ORIGIN = 'https://www.thewastegame.com';

// Public registers used to check a waste carrier, broker or dealer registration.
// The same CBDU-style registration numbers are issued by both regulators.
export const EA_CARRIER_REGISTER =
  'https://environment.data.gov.uk/public-register/view/search-waste-carriers-brokers';

export const NRW_CARRIER_REGISTER =
  'https://naturalresources.wales/permits-and-permissions/waste-carriers-brokers-and-dealers-public-register/?lang=en';

// Google Play listing for the Android app.
export const PLAY_STORE_URL =
  'https://play.google.com/store/apps/details?id=uk.co.thewastegame.www.twa';

// Public profiles linked from the footer and Organization sameAs.
// The Facebook Page has no vanity URL, so the profile id URL is the canonical link.
export const SOCIAL_LINKS = [
  { name: 'Instagram', href: 'https://www.instagram.com/the_wastegame/' },
  { name: 'TikTok', href: 'https://www.tiktok.com/@thewastegame' },
  { name: 'X', href: 'https://x.com/thewastegame' },
  { name: 'Facebook', href: 'https://www.facebook.com/profile.php?id=61574705870895' },
];

export const SOCIAL_SAME_AS = SOCIAL_LINKS.map((link) => link.href);
